import { useEffect, useRef } from 'react';
import { trimStart, isEmpty, isNumber } from 'lodash';

export const useScrollToAnchorOnInit = ({
    hash,
    enabled = true,
    delay = 1000,
    scrollOffset
}: {
    hash: string;
    enabled?: boolean;
    delay?: number;
    scrollOffset?: number;
}) => {
    const effectTriggeredRef = useRef<boolean>(false);
    useEffect(() => {
        if (effectTriggeredRef.current && enabled) {
            return;
        }

        effectTriggeredRef.current = true;

        const _hash = trimStart(hash, '#');
        if (isEmpty(_hash)) {
            return;
        }

        setTimeout(() => {
            const el = document.querySelector(`a[name="${_hash}"]`);
            if (!el) {
                return;
            }

            if (isNumber(scrollOffset)) {
                window.scrollTo({
                    behavior: 'smooth',
                    top: el.getBoundingClientRect().top - document.body.getBoundingClientRect().top - scrollOffset
                });
            } else {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, delay);
    }, [delay, enabled, hash, scrollOffset]);
};
